import React, {Component} from 'react';
import MVPDs from '../data/mvpds.json';
let channelLogos = 
	{
		"Mystery": "images/HMyst-24_LOGO_Black_v2.png",
		"Channel": "images/HC_Logo_New_Black.png",
		"Family": "images/HF_LOGO_Black.png"
	}
class MobileProvider extends Component
{
	render()
	{
		let MVPD = MVPDs[this.props.operator];
		// let MVPD = MVPDs[this.props.name];
		return(
			<div className="single-mobile-provider">
				<div className="row">
					<div className="col-xs-6"><h3 className="mobile-provider-heading">Provider:</h3></div>
					{MVPD ? 
					(<div className="col-xs-6 align-center">
						<img className="mobile-provider-logo" src={MVPD} alt={this.props.operator}/>
						{/* <img className="mobile-provider-logo" src={MVPD} alt={this.props.name}/> */}
						<div className="row">
							<span className="hd-icon-text">HD</span>
								<span>  </span>
							<span className="sd-icon-text">SD</span>
						</div>
					</div>)
					: 
					(<div className="col-xs-6 align-center">
						<div className="mobile-provider-name">{this.props.operator}</div>
						{/* <div className="mobile-provider-name">{this.props.name}</div> */}
						<div className="row">
							<span className="hd-icon-text">HD</span>
								<span>  </span>
							<span className="sd-icon-text">SD</span>
						</div>
					</div>)
					}
				</div>
				
				<div className="row">
					<div className="col-xs-6 align">					
						<img className="mobile-channel-logo" alt={this.props.order[0]} src={channelLogos[this.props.order[0]]}/>
					</div>
					<div className="col-xs-6">
                        <h3><span className="float-left">{this.props.mvpd[0].HD ? this.props.mvpd[0].HD.channelNumber : "N/A"}</span><span className={this.props.mvpd[0].SD && this.props.mvpd[0].SD.channelNumber.indexOf("/") > -1 ? "float-right small-font" : "float-right"}>{this.props.mvpd[0].SD ? this.props.mvpd[0].SD.channelNumber : "N/A"}</span></h3>
					</div>
				</div>
					<div className="row">
					<div className="col-xs-6">					
						<img className="mobile-channel-logo" alt={this.props.order[1]} src={channelLogos[this.props.order[1]]}/>
					</div>
					<div className="col-xs-6">
                        <h3><span className="float-left">{this.props.mvpd[1].HD ? this.props.mvpd[1].HD.channelNumber : "N/A"}</span><span className={this.props.mvpd[1].SD && this.props.mvpd[1].SD.channelNumber.indexOf("/") > -1 ? "float-right small-font" : "float-right"}>{this.props.mvpd[1].SD ? this.props.mvpd[1].SD.channelNumber : "N/A"}</span></h3>
					</div>
				</div>
					<div className="row">
					<div className="col-xs-6">					
						<img className="mobile-channel-logo" alt={this.props.order[2]} src={channelLogos[this.props.order[2]]}/>
					</div>
					<div className="col-xs-6">
                        <h3><span className="float-left">{this.props.mvpd[2].HD ? this.props.mvpd[2].HD.channelNumber : "N/A"}</span><span className={this.props.mvpd[2].SD && this.props.mvpd[2].SD.channelNumber.indexOf("/") > -1 ? "float-right small-font" : "float-right"}>{this.props.mvpd[2].SD ? this.props.mvpd[2].SD.channelNumber : "N/A"}</span></h3>
					</div>
				</div>
			</div>
		)
	}
}

export default MobileProvider;


// WEBPACK FOOTER //
// ./src/components/MobileProvider.js